import { Button, TextField } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  display: flex;
  color: #000;
  position: relative;

  @media only screen and (max-width: 991px) {
    flex-direction: column;
  }
`;

export const LoginTopRightImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
`;

export const Left = styled.div`
  width: 50%;
  height: 100%;
  position: relative;

  @media only screen and (max-width: 991px) {
    width: 100%;
  }
`;

export const BgImg = styled.img`
  height: 100%;
  width: 105%;
  position: absolute;
  z-index: 1;
`;

export const LeftContent = styled.div`
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  width: calc(100% - 1.5rem);
  height: calc(100% - 3rem);
  z-index: 2;
  display: flex;
  border-radius: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 1rem 4rem;
  background: #faf0ff;
  border: 1px solid #ebdbf2;

  h3 {
    color: #00000099;
  }

  h2 {
    display: flex;
    align-items: flex-end;
    font-size: 2rem;
    text-align: center;

    h3 {
      font-size: 2rem;
      color: #ffc700;
      text-decoration: underline;
      text-align: center;
    }
  }
  @media only screen and (max-width: 991px) {
    position: static;
    width: 100%;
    border-radius: 0;
  }
`;

export const Logo = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  h2 {
    font-weight: 600;
    font-size: 2rem;
    color: #000000;
  }

  img {
    margin-right: 0.8rem;
  }
`;

export const FeatureImg = styled.img`
  width: 20rem;
  margin: 3rem 0;
`;

export const RightDetail = styled.div`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    display: flex;
    align-items: flex-end;
    font-size: 1.3rem;

    h3 {
      color: #ffc700;
      text-decoration: underline;
    }
  }

  p {
    margin-top: 0.5rem;
    margin-bottom: 10vh;
    text-align: center;
    color: #0b1a3366;
  }

  /* @media only screen and (max-width: 1000px) {
    display: flex;
  } */
`;

export const Right = styled.div`
  display: flex;
  /* height: 100%; */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0rem 8rem;
  flex: 1;

  @media only screen and (max-width: 991px) {
    width: 90%;
    margin: 0 0 5% 0;
  }
`;

export const ResetPasswordWrapper = styled.div`
  width: 100%;

  h3 {
    font-size: 1.4rem;
    margin-bottom: 0.4rem;
  }

  p {
    margin-bottom: 3rem;
    /* color: #ffffff99; */
  }

  @media only screen and (max-width: 991px) {
    margin-bottom: 8%;
  }
`;

export const InputLabel = styled.label`
  width: 100%;
  margin-bottom: 0.1rem;
`;

export const Input = styled.div`
  margin: 1.5rem 0;
  display: flex;
  flex-direction: column;
`;

export const LinkSentModal = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 36rem;
  border-radius: 1.3rem;
  overflow: hidden;
  outline: none;
  overflow: hidden;
  /* background: linear-gradient(97.29deg, #00258F 10.08%, #001963 99.77%);
    border: 1.5px solid rgba(64, 79, 129, 0.58);
    backdrop-filter: blur(16px); */
  background-color: #fff;

  img {
    width: 100%;
  }
`;

export const LinkSentModalBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 1.5rem;
  /* color: #fff; */

  h3 {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  p {
    color: #616161;
    font-size: 0.9rem;
    font-weight: 300;
  }
`;
export const Para = styled.p`
  margin: 5px 0 0 0 !important;
  padding: 0 !important;
`;

export const FormHeader = styled.h3`
  margin: 0 0 !important;
  padding: 0 !important;
  font-weight: 700;
`;

export const Btn = styled(Button)`
  width: 100% !important;
  border-radius: 0.75rem !important;
  text-transform: none !important;
  color: rgb(255, 255, 255) !important;
  background: linear-gradient(270deg, rgb(0, 102, 255) 0%, rgb(0, 148, 255) 100%);
  padding: 10px 22px 8px !important;
`;

export const InputField = styled(TextField)`
  > .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 10px !important;
  }
  > .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 10px !important;
  }
  > .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 10px !important;
  }
`;
